var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-scene-container"},[_c('MScene',{ref:"sceneRef",attrs:{"background":"/static/image/air-monitor/scene.jpg","polygons":[]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }